import React, { useState } from "react";
import api from '../../api/axiosInstance';
import { Card, Form, Button, Alert } from "react-bootstrap";
import AdminLayout from "../../components/admin/AdminLayout";
import QuillEditor from "../../components/QuillEditor";

const AddBlogPage = () => {
  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [content, setContent] = useState("");
  const [message, setMessage] = useState(null);

  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post(
        "/blogs",
        { title, content, imageUrl },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage({ type: "success", text: res.data.message });
      setTitle("");
      setImageUrl("");
      setContent("");
    } catch (err) {
      setMessage({
        type: "danger",
        text: err.response?.data?.message || "Hata oluştu.",
      });
    }
  };

  return (
    <AdminLayout>
      <Card className="p-4 shadow-sm" style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h3 className="text-center mb-4" style={{ color: "#2D8A7A" }}>
          Yeni Blog Ekle
        </h3>

        {message && <Alert variant={message.type}>{message.text}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Başlık</Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Resim URL (opsiyonel)</Form.Label>
            <Form.Control
              type="text"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>İçerik</Form.Label>
            <QuillEditor value={content} onChange={setContent} />
          </Form.Group>

          <Button type="submit" className="btn-primary w-100 mt-3">
            Oluştur
          </Button>
        </Form>
      </Card>
    </AdminLayout>
  );
};

export default AddBlogPage;
